var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-item__content--rich-text"},[_c('div',{staticClass:"content-wrap"},[_c('iframe',{attrs:{"src":_vm.url,"scrolling":"yes"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }